import vertexShader from "../../shaders/vertex.vert";
import fragmentShader from "../../shaders/ground.frag";
import MAD from "../mad-engine";

export default class Ground extends MAD.Entity{
    constructor(){
        super();
        this.size = new THREE.Vector2(500,500);
        this.geometry = new THREE.PlaneGeometry( this.size.x, this.size.y, 1, this.size.y);

        const uniforms = {
            u_size: { type: "vec2", value: this.size },
            u_progress: { type: "float", value: 0 },
            u_curve: { type: "float", value: 0 }
        };
        this.material =  new THREE.ShaderMaterial( {
            vertexShader,
            fragmentShader,
            uniforms
        } );
        this.mesh = new THREE.Mesh( this.geometry, this.material );
        this.mesh.position.set(0,-30, -this.size.y / 2);
        this.mesh.rotation.set(-Math.PI/2,0,0);
        this.root.add( this.mesh );

        this.geometryData = {};
    }

    update(){
        const { clock } = MAD.App.instance;
        const { noise } = MAD.STORE.data;
        this.material.uniforms.u_progress.value = noise.getProgress();
        this.material.uniforms.u_curve.value = noise.getCurve();
        this.material.uniforms.needsUpdate = true;
    }
}